import { Text } from "@mantine/core";
import type { ReactNode } from "react";

interface ParagraphProps {
  children?: ReactNode;
}

/**
 * Paragraph renders a body paragraph as Mantine `Text`.
 */
export const Paragraph = ({ children }: ParagraphProps) => <Text my="sm">{children}</Text>;
